import { useCallback, useEffect, useState } from "react";
import {
  useDownloadEcasFileMutation,
  useLazyGetBlImportsQuery,
} from "../../../services/bl-import/BLImportService";
import { useFormik } from "formik";
import * as yup from "yup";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setPageTableBlImport } from "../slices/blImportSlice";
import { BLImport } from "../../../interfaces/bl-import/blImport.interface";

const schema = yup.object().shape({
  type: yup.string().required("Tipo de filtro es requerido"),
  value: yup.string().required("Valor de filtro es requerido"),
  filter_days: yup.string(),
});

const useBLImport = () => {
  const [filterCounter, setFilterCounter] = useState(0);
  const { userInfo } = useAppSelector((state) => state.auth);
  const { page, size } = useAppSelector((state) => state.blImport);
  const dispatch = useAppDispatch();
  const [filter, setFilter] = useState("");
  const [value, setValue] = useState("");
  const [showDonloaded, setShowDonwloaded] = useState(false);
  const [filterDays, setFilterDays] = useState("");
  const [fetchBls, { data: dataBls, isLoading, isFetching, isError }] =
    useLazyGetBlImportsQuery();
  const [downloadEcas, { isSuccess: isSuccessDownloadEcas }] =
    useDownloadEcasFileMutation();

  const getBlsImp = useCallback(() => {
    fetchBls({
      page,
      size,
      type_filter: filter,
      value_filter: value,
      id_usuario: userInfo?.perfil === "1" ? undefined : userInfo?.id!,
      descargados: showDonloaded === true ? showDonloaded : undefined,
      filter_days: filterDays,
    });
    if (filterCounter) return;
  }, [
    fetchBls,
    page,
    size,
    filter,
    value,
    userInfo?.perfil,
    userInfo?.id,
    showDonloaded,
    filterDays,
    filterCounter,
  ]);

  const onChangeDownloaded = (newvalue: boolean) => {
    setShowDonwloaded(newvalue);
  };

  const onChangeFilterDays = (newValue: string) => {
    setFilterDays(newValue);
  };

  const clearFilters = () => {
    setFilter("");
    setValue("");
    setFilterDays("");
    setShowDonwloaded(false);
    resetForm();
  };

  const {
    getFieldProps,
    errors,
    touched,
    handleSubmit,
    resetForm,
    values,
    setFieldValue,
  } = useFormik({
    initialValues: {
      type: "",
      value: "",
      filter_days: "",
    },
    validationSchema: schema,
    onSubmit: async () => {
      setFilter(values.type);
      setValue(values.value);
      setFilterCounter((val) => val + 1);
      dispatch(setPageTableBlImport(0));
    },
  });

  // File downloads methods

  const handleDownloadEcas = async (bl: BLImport) => {
    downloadEcas({
      id_bl: bl.id!,
      id_usuario: Number(userInfo?.id!),
      fileName: bl.nombre_archivo_ecas!,
    });
  };

  useEffect(() => {
    getBlsImp();
    return;
  }, [getBlsImp, isSuccessDownloadEcas]);

  return {
    filter,
    value,
    showDonloaded,
    filterDays,
    onChangeDownloaded,
    onChangeFilterDays,
    clearFilters,
    dataBls,
    isLoading,
    isFetching,
    isError,
    getBlsImp,
    getFieldProps, // Formik Handlers
    errors, // Formik Handlers
    touched, // Formik Handlers
    handleSubmit, // Formik Handlers
    resetForm, // Formik Handlers
    values, // Formik Handlers
    setFieldValue, // Formik Handlers
    handleDownloadEcas,
  };
};

export default useBLImport;
